/**
 * Provides selectors for the objects that are stored.
 */
export enum StorageSelectors {
  sessionData = 'sessionData',
  locale = 'locale',
  deviceHasCompletedWalkthrough = 'deviceHasCompletedWalkthrough',
  cookieHeader = 'cookieHeader',
  scope = 'portal',
  retailerScope = 'retailerScope'
}
